import React from 'react';
import { GuardianIcon } from 'glic-ui-components';
import { giEmergency } from 'glic-ui-components/dist/icons';
import logo from '../../../assets/guardian-logo.svg';
import './index.scss';

const index = (props) => {
  console.log("Props in pareant component?????", props);
 
  const {
    alertMainHeading,
    alertInfoText,
    registerBtn,
  } = props?.propData;

  console.log("alertMainHeading>>>>>", alertMainHeading, alertInfoText, "alertInfoText")

  return (
    <div>
      <div className="alert_nav_container"  role="banner">
        <img alt="Guardian-Logo" className="guardian_logo" src={logo} />
      </div>

      <div className="separator_line" />

      <div className="alert_container" role="main"> 
        <div>
          <GuardianIcon icon={giEmergency} className="emergency_icon" assistiveText="warning" />
        </div>
        <h1 className="alert_main_heading">{alertMainHeading}</h1>
        <p className="alert_info_text">{alertInfoText}</p>
        <div>{registerBtn}</div>
      </div>
    </div>
  );
};

export default index;